module.exports = __webpack_public_path__ + "static/media/profile-2.a4011de5.png";